// extracted by mini-css-extract-plugin
export default {"priceDetails":"PriceDetails_priceDetails__KRhHa"};